import { render } from "./Doomclock.vue?vue&type=template&id=48f8956d&scoped=true"
import script from "./Doomclock.vue?vue&type=script&lang=js"
export * from "./Doomclock.vue?vue&type=script&lang=js"

import "./Doomclock.vue?vue&type=style&index=0&id=48f8956d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f8956d"]])

export default __exports__